import { computePosition, type ClientRectObject, type VirtualElement } from "@floating-ui/dom";
import { unmount } from "svelte";
import { createClassComponent } from "svelte/legacy";
import SuggestionMenu from "#lib/components/content-editors/extensions/SuggestionMenu.svelte";
import { showElement } from "#lib/components/content-editors/extensions/utils.js";
import { Logger } from "#lib/logging.js";
import type { SuggestionKeyDownProps, SuggestionProps } from "@tiptap/suggestion";

export function suggestionRenderer() {
	let wrapper: HTMLDivElement;
	let component: ReturnType<typeof SuggestionMenu>;
	return {
		onStart(props: SuggestionProps) {
			const virtualElement: VirtualElement = {
				getBoundingClientRect() {
					return props.clientRect?.() as ClientRectObject;
				},
			};

			wrapper = document.createElement("div");
			document.body.appendChild(wrapper);

			component = createClassComponent({
				component: SuggestionMenu,
				target: wrapper,
				props: { props },
			});

			Object.assign(wrapper.style, {
				position: "absolute",
				zIndex: 10,
				opacity: 0,
				transition: "opacity 0.2s ease-in-out",
			});

			computePosition(virtualElement, wrapper, { placement: "bottom-start" })
				.then(({ x, y }) => showElement(wrapper, x, y))
				.catch(err => Logger.error("Failed to compute position for suggestion component", { err }));
		},

		onUpdate(props: SuggestionProps) {
			component?.$set?.({ props });
		},

		onExit() {
			unmount(component).catch(err => Logger.error("Failed to unmount suggestion component on exit", { err }));
			wrapper.remove();
		},

		onKeyDown(props: SuggestionKeyDownProps) {
			if (props.event.key === "Escape") {
				return true;
			}
			return component.onKeyDown(props);
		},
	};
}
